module.exports = __webpack_public_path__ + "static/media/taxijoin_06.1d98d2b1.png";